export const CreatorDepartmentStandard = [
  { _id: 'contentmarketing', name: 'Content marketing' },
  { _id: 'merchandising', name: 'Merchandising' },
  { _id: 'digitalmarketing', name: 'Digital marketing' },
];

export const VERSIONS = [
  { _id: 'licensePlate', name: 'Deutsches Kennzeichen' },
  { _id: 'original', name: 'Original' },
  { _id: 'retouching', name: 'Retusche' },
];

export const IMAGE_SOURCE = [
  { _id: 'licensePlate', name: 'CAP / IIF' },
  { _id: 'photoShoot', name: 'Eigenproduktion / Fotoshooting' },
  { _id: 'other', name: 'Sonstige' },
  { _id: 'stock', name: 'Stock' },
];

export const CreatorDepartmentVorwerk = [
  { _id: 'viBrandMarketing', name: 'VI Brand Marketing' },
  { _id: 'viContentMarketing', name: 'VI Content Marketing' },
  { _id: 'viCorporateCommunications', name: 'VI Corporate Communications' },
  { _id: 'viMerchandising', name: 'VI Merchandising' },
  { _id: 'viOther', name: 'VI Other' },
  { _id: 'grc', name: 'GRC' },
  { _id: 'vorwerkFranceGRC', name: 'Vorwerk France GRC' },
  { _id: 'vorwerkGermany', name: 'Vorwerk Germany' },
];
